import api from '../api';

const BASE_URL = '/api/v2/program-segments';

const SegmentsAPI = {
	getAll: ({ query = '' } = {}) => api.get(`${BASE_URL}?${query}`),
	create: ({ payload }) => api.post(BASE_URL, payload),
	update: ({ id, payload }) => api.patch(`${BASE_URL}/${id}`, payload),
	delete: ({ id }) => api.delete(`${BASE_URL}/${id}`),
};

export default SegmentsAPI;
